import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "autocomplete-suggestions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.suggestions, (suggestion, index) => {
      return (_openBlock(), _createBlock($setup["Suggestion"], {
        key: index,
        suggestion: suggestion,
        query: $props.query,
        onClick: ($event: any) => ($setup.setSuggestion(suggestion))
      }, null, 8 /* PROPS */, ["suggestion", "query", "onClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}